if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();
      this.input.addEventListener('change', this.updateQuantityPricing.bind(this));
      this.addEventListener('change', (event) => {
        if (event.target.closest('#rc_container, [id^="RechargeWidget_"]')) {
          this.updateQuantityPricing();
          setTimeout(() => this.updateQuantityPricing(), 300);
        }
      });
      this.addEventListener('click', (event) => {
        if (event.target.closest('#rc_container, [id^="RechargeWidget_"]')) {
          setTimeout(() => this.updateQuantityPricing(), 0);
          setTimeout(() => this.updateQuantityPricing(), 300);
        }
      });

      const rcContainer = this.querySelector('#rc_container');
      if (rcContainer) {
        this.rcObserver = new MutationObserver(this.updateQuantityPricing.bind(this));
        this.rcObserver.observe(rcContainer, { childList: true, subtree: true, characterData: true });
      }

      const rcVueWidget = this.getRechargeWidget();
      if (rcVueWidget) {
        this.rcVueObserver = new MutationObserver(this.updateQuantityPricing.bind(this));
        this.rcVueObserver.observe(rcVueWidget, { childList: true, subtree: true, characterData: true });
      }

      this.rcInterval = setInterval(this.updateQuantityPricing.bind(this), 500);

      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
      if (this.rcObserver) {
        this.rcObserver.disconnect();
      }
      if (this.rcVueObserver) {
        this.rcVueObserver.disconnect();
      }
      if (this.rcInterval) {
        clearInterval(this.rcInterval);
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (!this.input.dataset.quantityLimitActive && data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      this.updateQuantityPricing();
    }

    updateQuantityPricing() {
      const packSize = this.input.dataset.packSize ? parseInt(this.input.dataset.packSize) : 0;
      const basePrice = this.input.dataset.basePrice ? parseInt(this.input.dataset.basePrice) : 0;
      if (!packSize || !basePrice || typeof formatMoney !== 'function') return;

      const quantity = parseInt(this.input.value) || packSize;
      const totalCents = Math.round(basePrice * quantity);
      const formatted = formatMoney(totalCents, window.themeMoneyFormat);

      if (this.subscriptionRatio === undefined && !this.rcPricingWritten) {
        const ratio = this.captureSubscriptionRatio();
        if (ratio) this.subscriptionRatio = ratio;
      }

      const discount = this.input.dataset.subscriptionDiscount ? parseFloat(this.input.dataset.subscriptionDiscount) : 0;
      let subCents = null;
      if (this.subscriptionRatio) {
        subCents = Math.round(totalCents * this.subscriptionRatio);
      } else if (discount) {
        subCents = Math.round(totalCents * (1 - discount / 100));
      }
      const subFormatted = subCents === null ? null : formatMoney(subCents, window.themeMoneyFormat);

      const isSubscriptionSelected = this.isSubscriptionSelected();
      const displayFormatted = (isSubscriptionSelected && subFormatted) ? subFormatted : formatted;

      this.querySelectorAll('.money-price').forEach((el) => {
        if (el.textContent !== displayFormatted) el.textContent = displayFormatted;
      });

      this.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach((el) => {
        if (el.textContent.trim() !== displayFormatted) el.textContent = displayFormatted;
      });

      if (subFormatted === null) return;

      const onetimeEl = this.querySelector('#rc_price_onetime');
      if (onetimeEl && onetimeEl.textContent !== formatted) onetimeEl.textContent = formatted;

      const autodeliverEl = this.querySelector('#rc_price_autodeliver');
      if (autodeliverEl && autodeliverEl.textContent !== subFormatted) autodeliverEl.textContent = subFormatted;

      const rcVueWidget = this.getRechargeWidget();
      if (rcVueWidget) {
        const moneyPattern = /\$[\d,]+\.?\d*/;
        rcVueWidget.querySelectorAll('.rc-radio__label').forEach((label) => {
          const isSubscription = label.closest('.rc-radio')?.classList.contains('subscription-radio');
          const target = isSubscription ? subFormatted : formatted;
          if (moneyPattern.test(label.textContent) && !label.textContent.includes(target)) {
            label.textContent = label.textContent.replace(moneyPattern, target);
          }
        });
      }

      this.rcPricingWritten = true;
    }

    getRechargeWidget() {
      return this.querySelector('[id^="RechargeWidget_"]') || document.querySelector('[id^="RechargeWidget_"]');
    }

    isSubscriptionSelected() {
      // The visible Recharge widget wins. The legacy #rc_container is only rendered for products
      // with old subscription metafields, stays hidden, and defaults to "autodeliver" checked.
      const rcVueWidget = this.getRechargeWidget();
      if (rcVueWidget) {
        const radioChecked = rcVueWidget.querySelector('.rc-radio input:checked');
        if (radioChecked) return radioChecked.closest('.rc-radio').classList.contains('subscription-radio');

        const vueChecked = rcVueWidget.querySelector('input[name="purchaseOption"]:checked');
        if (vueChecked) return vueChecked.value !== 'onetime';

        const activeRadio = rcVueWidget.querySelector('.rc-radio--active');
        if (activeRadio) return activeRadio.classList.contains('subscription-radio');
      }

      const rcContainer = this.querySelector('#rc_container');
      if (rcContainer && rcContainer.offsetParent !== null) {
        const legacyChecked = rcContainer.querySelector('input[name="purchase_type"]:checked');
        if (legacyChecked) return legacyChecked.value !== 'onetime';
      }

      return false;
    }

    captureSubscriptionRatio() {
      const numberPattern = /\$[\d,]+\.?\d*/;
      let onetimeVal, subVal;

      const rcVueWidget = this.getRechargeWidget();
      if (rcVueWidget) {
        const onetimeLabel = rcVueWidget.querySelector('.onetime-radio .rc-radio__label');
        const subLabel = rcVueWidget.querySelector('.subscription-radio .rc-radio__label');
        const onetimeMatch = onetimeLabel && onetimeLabel.textContent.match(numberPattern);
        const subMatch = subLabel && subLabel.textContent.match(numberPattern);
        if (onetimeMatch) onetimeVal = parseFloat(onetimeMatch[0].replace(/[$,]/g, ''));
        if (subMatch) subVal = parseFloat(subMatch[0].replace(/[$,]/g, ''));
      }

      if (onetimeVal === undefined || subVal === undefined) {
        const onetimeEl = this.querySelector('#rc_price_onetime');
        const autodeliverEl = this.querySelector('#rc_price_autodeliver');
        const onetimeMatch = onetimeEl && onetimeEl.textContent.match(numberPattern);
        const subMatch = autodeliverEl && autodeliverEl.textContent.match(numberPattern);
        if (onetimeMatch) onetimeVal = parseFloat(onetimeMatch[0].replace(/[$,]/g, ''));
        if (subMatch) subVal = parseFloat(subMatch[0].replace(/[$,]/g, ''));
      }

      if (onetimeVal && subVal && onetimeVal > 0) {
        return subVal / onetimeVal;
      }
      return null;
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  }
)};



